import { render, staticRenderFns } from "./laiyuandi.vue?vue&type=template&id=616c7e12&scoped=true"
import script from "./laiyuandi.vue?vue&type=script&lang=js"
export * from "./laiyuandi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c7e12",
  null
  
)

export default component.exports